import {SponsorEQuery} from './sponsor-e-query';
import {dataMember, required, typedArray} from 'santee-dcts';

export class SponsorEQueriesReadModel {
    @dataMember()
    @required()
    @typedArray(SponsorEQuery)
    public eQueries: SponsorEQuery[];
}
